import React, { useEffect, useRef } from 'react'
import { CreationToolSourceFile } from '../types'

type Props = {
    className?: string
    source: CreationToolSourceFile
}

const CreationToolsSourceThumbnail = ({ className, source }: Props) => {
    const canvasRef = useRef<HTMLCanvasElement>(null)

    useEffect(() => {
        if (!canvasRef.current || !source.preview) return

        const preview = source.preview
        const canvas = canvasRef.current
        const context = canvas.getContext('2d')
        const previewSize = Math.min(preview.width, preview.height)
        const previewMid = previewSize / 2

        canvas.width = previewSize
        canvas.height = previewSize
        context?.drawImage(preview, previewMid - preview.width / 2, previewMid - preview.height / 2)
    }, [canvasRef, source.preview])

    return <canvas className={className} ref={canvasRef} />
}

export default CreationToolsSourceThumbnail
